export default __webpack_public_path__ + "static/media/mapa.2044d799.png";